import {Component, Input, OnInit} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatCardModule} from "@angular/material/card";
import {MatDividerModule} from "@angular/material/divider";
import {CommonModule} from "@angular/common";
import {ContactInfoModel} from "../../domain/models/contact-info.model";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {ContactType} from "../../domain/enums/bed-contact-type.enum";
import {EnrollmentModel} from "../../domain/models/enrollment.model";
import {ContactInfoCardComponent} from "../contact-info-card/contact-info-card.component";
import {CompanyInfoCardComponent} from "../company-info-card/company-info-card.component";
import {CompanyInfoModel} from "../../domain/models/company-info.model";
import {FormValidationUtil} from "../../utils/form-validation.util";

@Component({
  selector: 'app-bed-contact-info',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    RouterModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    ReactiveFormsModule,
    MatDividerModule,
    CommonModule,
    MatRadioButton,
    MatRadioGroup,
    ContactInfoCardComponent,
    CompanyInfoCardComponent
  ],
  templateUrl: './bed-contact-info.component.html',
  styleUrl: './bed-contact-info.component.css'
})
export class BedContactInfoComponent implements OnInit{
  @Input() model: EnrollmentModel = {};
  companyForm!: FormGroup;
  ownerForm!: FormGroup;
  contactType: ContactType = ContactType.OWNER;
  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.buildContactInfoFrom(this.model);
    this.buildCompanyInfoForm(this.model);
  }

  buildContactInfoFrom(info: ContactInfoModel): void {
    this.ownerForm = this.fb.group({
      firstName: [info.firstName?? '', Validators.required],
      lastName: [info.lastName?? '', Validators.required],
      email: [info.email?? '', [Validators.required, Validators.email]],
      phone: [info.phoneNumber?? '', [Validators.required,
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())]],
      eSignature: [{value:info.printedName?? '', disabled:true}],
    });
  }

  private getContactInfoFromForm(): ContactInfoModel {
    return {
      firstName: this.ownerForm.get('firstName')?.value ?? null,
      lastName: this.ownerForm.get('lastName')?.value ?? null,
      email: this.ownerForm.get('email')?.value ?? null,
      phoneNumber: this.ownerForm.get('phone')?.value ?? null,
      printedName: this.ownerForm.get('eSignature')?.value ?? null
    };
  }

  buildCompanyInfoForm(info: CompanyInfoModel): void {
    this.companyForm = this.fb.group({
      businessLegalName: [info.businessLegalName?? null, Validators.required],
      businessDbaName: [info.businessDbaName?? null, Validators.required],
      webSiteUrl: [info.webSiteUrl?? null, [Validators.required,
        Validators.pattern(FormValidationUtil.getUrlValidationPattern())]],
    });
  }

  private getCompanyInfoFromForm(): CompanyInfoModel {
    return {
      businessLegalName: this.companyForm.get('businessLegalName')?.value ?? null,
      businessDbaName: this.companyForm.get('businessDbaName')?.value ?? null,
      webSiteUrl: this.companyForm.get('webSiteUrl')?.value ?? null
    };
  }

  isFormValid(): boolean {
    return this.getForm().valid ;
  }

  getForm(): FormGroup {
    if (this.contactType === ContactType.OWNER) {
      return this.ownerForm;
    } else {
      return this.companyForm;
    }
  }

  protected readonly ContactType = ContactType;


  getModelFromForm() {
    if (this.contactType === ContactType.OWNER) {
      return this.getContactInfoFromForm();
    } else {
      return this.getCompanyInfoFromForm();
    }
  }
}
